import { IconEyeSlash } from '@machobear/design-system'
import { DropdownButton } from './dropdown-button'
import { PulsatingDot } from './pulsating-dot'
import { ListingHidingControl } from './listing-hiding-control'
import { IntegrationDetails } from './integration-details'
import { useListingData } from '../../context/listing-data'

const states: any = {
  hidden: {
    icon: <IconEyeSlash tone="neutralInverted" />,
    label: 'Hidden',
    tone: 'formAccent'
  },
  pending: {
    icon: <PulsatingDot color="#723D02" />,
    label: 'Pending',
    tone: 'caution'
  },
  published: {
    icon: <PulsatingDot color="#12784F" />,
    label: 'Published',
    tone: 'positive'
  }
}

export const ListingStateButton = () => {
  const { listingPending, listingHidden, isImported } = useListingData()

  if (isImported) {
    return (
      <DropdownButton {...states.published}>
        <IntegrationDetails />
      </DropdownButton>
    )
  }

  const state = listingHidden ? 'hidden' : listingPending ? 'pending' : 'published'

  return (
    <DropdownButton {...states[state]}>
      <ListingHidingControl />
    </DropdownButton>
  )
}
